<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-footer
            class="col-12"
            disable-pagination
        >
            <template v-slot:[`item.btn_up`]="{ item }">
                <v-btn
                    :disabled="btn[1].isActive || item.priority == 1"
                    color="primary"
                    @click="changePiority(item, -1)">△</v-btn>
            </template>
            <template v-slot:[`item.btn_down`]="{ item }">
                <v-btn
                    :disabled="btn[1].isActive || item.priority == dataCount"
                    color="primary"
                    @click="changePiority(item, 1)">▽</v-btn>
            </template>
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="btn[1].isActive"
                color="green darken-4"
                text
                @click="comfirmUpdate">登録</v-btn>
        </v-card-actions>
        <v-overlay :value="dataUpdate">
            <v-card light width="500px">
                <v-card-title v-if="result === 0">優先順位登録の最終確認</v-card-title>
                <v-card-title v-if="result >= 1">優先順位</v-card-title>
                <v-card-text v-if="result === 0">優先順位を変更します。</v-card-text>
                <v-card-text>{{ resultText }}</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="result === 0" color="primary" text @click="dataUpdate = !dataUpdate">キャンセル</v-btn>
                    <v-btn v-if="result === 0" color="primary" text @click="updateData(desserts)">登録する</v-btn>
                    <v-btn v-if="result === 1" color="primary" text @click="closeComfirm()">閉じる</v-btn>
                    <v-btn v-if="result > 1" color="primary" text @click="dataUpdate = !dataUpdate">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
        <v-overlay :value="showError">
            <v-card light width="500px">
                <v-card-title>優先順位登録</v-card-title>
                <v-card-text>{{ resultText }}</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showError = false">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
    </div>
</template>

<script>
// mixins
import { authorityMixin } from '@/views/authorityMixin';

// graghql
import { GET_SYSTEM_MASTER, UPDATE_SYSTEM_MASTER } from '@/constants/system_master';

export default {
    mixins: [authorityMixin],
    data () {
        return {
            golf_code: '',
            // v-data-tableのヘッダー
            headers: [
                { text: '優先順位', value: 'priority', sortable: false, align: 'center' },
                { text: 'アプリケーション名', value: 'setting_name', sortable: false },
                { text: '優先順位上げる', value: 'btn_up', sortable: false },
                { text: '優先順位下げる', value: 'btn_down', sortable: false }
            ],
            desserts: [],
            dataUpdate: false,
            showError: false,
            result: false,
            resultText: '',
            searchWord: 'cooperation_app',
            dataCount: '',
            data: [],
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '登録', isActive: true }
            ],
            vue_id: 'SCR0104'
        };
    },
    created () {
        this.Initialize();
    },
    methods: {
        async Initialize () {
            this.admin = await this.getLoginAdmin();
            this.getAuthorityList();
            await this.getData();
        },
        async getData () {
            try {
                this.$apollo.query({
                    query: GET_SYSTEM_MASTER,
                    fetchPolicy: 'no-cache',
                    variables: {
                        settingGroup: this.searchWord,
                        settingValue: 1
                    }
                }).then(res => {
                    this.desserts = res.data.GetSystemMaster.SystemMasterLists;
                    for (var i = 0; i < this.desserts.length; i++) {
                        this.desserts[i].priority = i + 1;
                    }
                    this.dataCount = this.settingCodeSlice(this.desserts.length, 2);
                });
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        updateData (lists) {
            try {
                this.$store.commit('loading/setIsLoading', true);
                let data = [];
                let obj = {};
                for (let list of lists) {
                    obj = {
                        setting_group: list.setting_group,
                        setting_key: list.setting_key,
                        setting_value: list.setting_value,
                        priority: list.priority
                    };
                    data.push(obj);
                }
                this.$apollo.mutate({
                    mutation: UPDATE_SYSTEM_MASTER,
                    variables: {
                        UpdateSystemMasterList: data
                    }
                }).then(res => {
                    this.result = res.data.UpdateSystemMaster.result;
                    if (this.result === 1) {
                        this.resultText = '正常終了しました。';
                    } else {
                        this.resultText = 'エラーが発生しました。';
                    }
                });
                this.$store.commit('loading/setIsLoading', false);
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        comfirmUpdate (item) {
            this.result = 0;
            this.resultText = '';
            this.dataUpdate = true;
        },
        closeComfirm () {
            this.Initialize();
            this.dataUpdate = false;
        },
        changePiority (item, num) {
            let newDesserts = [];
            let newNum = Number(item.priority) + num;
            for (let i = 0; i < this.desserts.length; i++) {
                let itemNum = Number(this.desserts[i]['priority']);
                if (itemNum === newNum) {
                    this.desserts[i]['priority'] = this.settingCodeSlice((newNum - num), 1);
                    newDesserts[(newNum - num - 1)] = this.desserts[i];
                } else if (itemNum === Number(item.priority)) {
                    this.desserts[i]['priority'] = this.settingCodeSlice(newNum, 1);
                    newDesserts[(newNum - 1)] = this.desserts[i];
                } else {
                    newDesserts[i] = this.desserts[i];
                }
            }
            this.desserts = [];
            this.desserts = newDesserts;
            this.dataCount = this.desserts.length;
        },
        settingCodeSlice (el, num) {
            let zero = '';
            for (let i = 0; i < num; i++) {
                zero = zero + '0';
            }
            const newel = (zero + el).slice(num * -1);
            return newel;
        }
    }
};
</script>

<style scoped>
.v-data-table{
    overflow-y: scroll;
    min-height: 200px;
    max-height: 600px;
}
</style>
